import {useCallback, useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {getNextDate, getSubmit, isEmpty, postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "../@constants";
import {checkingLogging, isLogged, nextUserCheck, userData} from "../@signals";


export default function useUserApp(needCheck=false) {

	const isLoadingLogin = useSignal(false)
	const error = useSignal(null)

	const setUserData = newData => batch(() => {
		userData.value = newData
		nextUserCheck.value = getNextDate({ hours: 1 }).getTime()
	})

	useEffect(() => batch(() => {
		if (!isLogged.value && needCheck) {
			getSubmit(`${BACKEND_APIS.SESSION}/check-login`).then(res => {
				setUserData(res)
				checkingLogging.value = false
			}).catch(() => batch(() => {
				if (!isEmpty(userData.value))
					userData.value = {}
				checkingLogging.value = false
			}))
		}
	}), [])

	const handleLogin = useCallback((username, password) => batch ( () => {
		isLoadingLogin.value = true
		postSubmit(`${BACKEND_APIS.SESSION}/login`, {
			username, password
		}).then(res => {
			if (res.error) {
				error.value = "Invalid username or password entered."
				isLoadingLogin.value = false
			} else {
				if (error.value)
					error.value = null
				setUserData(res)
				isLoadingLogin.value = false
			}
			if (checkingLogging.value)
				checkingLogging.value = false
		}).catch(() => {
			if (nextUserCheck.value)
				nextUserCheck.value = null
			error.value = 'Server call failed. Please try again.'
			isLoadingLogin.value = false
			if (checkingLogging.value)
				checkingLogging.value = false
		})
	}), [])

	const handleLogout = useCallback(() => batch(() => {
		nextUserCheck.value = null
		getSubmit(`${BACKEND_APIS.SESSION}/logout`).then(() => {
			if (!isEmpty(userData.value))
				userData.value = {}
			if (nextUserCheck.value)
				nextUserCheck.value = null
			if (checkingLogging.value)
				checkingLogging.value = false
		})
	}), [])

	return {
		isLogged: isLogged.value,
		checkingLogging: checkingLogging.value,
		isLoadingLogin: isLoadingLogin.value,
		error: error.value,

		userData: userData.value,
		username: userData.value.email,
		userRole: userData.value.role || 'user',
		isAdmin: userData.value.role === 'admin',
		userEnv: userData.value.env,

		handleLogin, handleLogout
	}
}